import { api } from './backend';

//export const update = (data) => api.patch('/front/professionals/', data);
export const post = (data) => api.post('front/ratings/', data);

export const get = () => api.get('front/ratings/');

export const getById = (id) => api.get(`front/ratings?page=1&limit=100&professional_id=${id}`);